import { Spin } from "antd";
export const Loader = ({ size }) => {
  return (
    <div className="fixed inset-0 flex justify-center items-center">
      <Spin size={size} />
    </div>
  );
};
